import React, { Component } from 'react';
import Classname from 'classnames';
import { ReactComponent as Back } from 'Icons/back-bordered.svg';
import { ReactComponent as Forward } from 'Icons/forward-bordered.svg';



class TransportersTableHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText : "",
            offset: props.offset || 0,
        }
    }
    getFilters = ()=> {
        return {
            search: this.state.searchText,
            offset: this.state.offset,
            limit: 10
        };
    }
    clearFilter = ()=> {
        this.props.fetchTransporters(this.getFilters(), true)
    } 
    applyFilter = ()=> {
        this.props.fetchTransporters(this.getFilters(), true)
    } 
    searchTransporters = (e)=> {
        this.setState({
            searchText: e.target.value,
            offset: 0
        }, this.applyFilter)
    }
    fetchNextTransporters = ()=> {
        this.setState({
            offset: this.state.offset + 10
        }, ()=> {
            this.props.fetchTransporters(this.getFilters());
        });
    }
    fetchPreviousTransporters = ()=> {
        this.setState({
            offset: this.state.offset - 10
        }, ()=> {
            this.props.fetchTransporters(this.getFilters());
        });
    }
    render() {
        const { 
            transportersCount, 
            header,
            searchPlaceholder,
            countText,
            viewMode,
            transporters
        } = this.props;
        const { offset } = this.state;
        return (
            <div className="flex flex-middle flex-between mb-30">
                <div className="fBold fs-22">
                    <span className="mr-10">{header || 'Transporters'}</span>
                    {/* {transportersCount && <span className="fs-12 fSemibold caption-color">{offset + 1} to {(offset + 10)<transportersCount?(offset + 10):transportersCount}</span>} */}
                </div>
                <div className="flex flex-middle">
                    <span className="clearable">
                    <input placeholder={searchPlaceholder || "Search Transporters"} 
                            type="text" 
                            className="mr-30 wt-200 br-20 ht-40 bg-gray search"
                            value={this.state.searchText}
                            onChange={this.searchTransporters}
                        />
                    {this.state.searchText && this.state.searchText.length > 0 &&   
                        <span 
                            className="clearable__clear" 
                            onClick={() => { 
                                this.setState({ searchText : "" }, 
                                    () => { console.log('searchText', this.state.searchText); this.clearFilter(); }); 
                            }}
                        >&times;</span>}
                    </span>
                    <Back className={Classname("mr-20", {
                        'fill-gray stroke-rect-gray': offset===0,
                        'fill-theme stroke-rect-theme curP': offset > 0
                    })} onClick={this.fetchPreviousTransporters}/>
                    <Forward className={Classname("mr-20", {
                        'fill-gray stroke-rect-gray': transportersCount <= (offset + 10),
                        'fill-theme stroke-rect-theme curP': transportersCount > offset+10
                    })} onClick={this.fetchNextTransporters}/>
                    {/* {transportersCount && <div className="bg-gray ht-25 flex flex-middle pl-15 pr-15 br-5 pr-1 fSemibold fs-16 header-medium-color">{tripsCount} {countText || 'trips added'}</div>} */}
                    {!viewMode && !this.props.editingGroup && 
                        <button className={Classname("ht-25 br-20 white-color bg-theme fs-14 fSemibold pl-15 pr-15 mr-20", {
                            disabled: transporters.length === 0
                        })} onClick={this.props.showCreateGroupPopup}> Create Group </button>
                    }
                    {!viewMode && this.props.editingGroup &&
                        <button className="ht-25 br-20 white-color bg-success fs-14 fSemibold pl-15 pr-15 mr-20" onClick={this.props.editGroup}> Add & Save </button>
                    }
                </div>
            </div>
        )
    }
}

export default TransportersTableHeader;
